import { COUPON_STATUS, COUPON_TYPE } from '../constants/index';

/**
 * 过滤出红包（多个商家可用的券）
 * @param {Array} infoList 商家列表
 * @returns 携带红包的商家
 */
export const filterRedBag = (infoList = []) => infoList.filter((poiInfo) => poiInfo.giftInfo && poiInfo.giftInfo.type === COUPON_TYPE.RED_BAG);

/**
 * 过滤出商家
 * @param {Array} infoList 商家列表
 * @returns 商家列表，不含有限定红包
 */
export const filterPoiList = (infoList = []) => infoList.filter((poiInfo) => poiInfo.poi_id_str);

/**
 * 过滤出带券的商家
 * @param {Array} infoList
 * @returns 带券的商家
 */
export const filterCouponList = (infoList = []) => infoList.filter((poiInfo) => poiInfo.poi_id_str && poiInfo.giftInfo);
/**
 * 过滤出未领取的券
 * @param {Array} infoList
 * @returns 过滤出未领取的券列表
 */
export const filterNewCoupon = (infoList = []) => {
    return infoList.filter((poiInfo) => poiInfo.giftInfo && poiInfo.giftInfo.status === COUPON_STATUS.STATUS_NEW);
};
/**
 * 未领取券的ID集合
 * @param {Array} infoList
 * @returns 未领取券的ID集合
 */
export const filterNewCouponIDs = (infoList = []) => filterNewCoupon(infoList).map((poiInfo) => poiInfo.giftInfo.gift_id);

/**
 * 筛选已经领取的券
 * @param {Array} infoList
 * @returns
 */
export const filterReceiveCoupon = (infoList = []) => {
    return infoList.filter((poiInfo) => poiInfo.giftInfo && poiInfo.giftInfo.status === COUPON_STATUS.STATUS_RECEIVED);
};

export const filterRedBagListWithSku = (infoList = []) => {
    return filterRedBag(infoList).filter((poiInfo) => {
        return poiInfo && Array.isArray(poiInfo.skuInfoList) && poiInfo.skuInfoList.length > 0;
    });
};

export const filterPoiInfoWidthSKu = (infoList = []) => {
    return filterPoiList(infoList).filter((poiInfo) => {
        return poiInfo && Array.isArray(poiInfo.skuInfoList) && poiInfo.skuInfoList.length > 0;
    });
};

export const filterPoiInfoWithActivityInfoList = (infoList = []) => {
    return infoList.filter((poiInfo) => {
        return poiInfo && Array.isArray(poiInfo.planActivityInfoList) && poiInfo.planActivityInfoList.length > 0;
    });
};
